/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputText/view.blocks to change it.
import InputPlain from 'DesignSystem/InputPlain/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function InputText({
  children,
  viewPath = "/DesignSystem/InputText",
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  autoComplete = "on",
  autoFocus,
  fontFamily = "Inter",
  fontSize = 16,
  marginBottom = 0,
  marginTop = 4,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  innerRef,
  isInvalid,
  invalidMessage,
  paddingRight = 8,
  placeholder,
  textTransform = "capitalize",
  type = "text",
  value,
  width = "auto"
  
}) {
  return (<React.Fragment
>
<InputPlain
  viewPath={`${viewPath}/InputPlain`}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 alignSelf="stretch"
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 className="mousetrap"
 color="#404040"
 fontFamily={fontFamily}
 fontSize={fontSize}
 fontWeight={300}
 marginBottom={marginBottom}
 marginTop={marginTop}
 onBlur={onBlur}
 onChange={onChange}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 innerRef={innerRef}
 isInvalid={isInvalid}
 invalidMessage={invalidMessage}
 paddingBottom={4}
 paddingLeft={0}
 paddingRight={paddingRight}
 paddingTop={4}
 placeholder={placeholder}
 textTransform={textTransform}
 type={type}
 value={value}
 width={width}
 className="mousetrap"
/>
{children}
</React.Fragment>)
}